import { getSession } from '@/utils'
import getCookieConsent from '@/utils/getCookieConsent'

import { logFrontendInfo } from '../_lib/frontendLogging'
import { TrackingData } from './_actions/getTrackingData'
import { getProducts } from './_ecommerce/products'
import { trackPurchaseEcommerce } from './_ecommerce/purchase'
import { trackOrderCompletedSegment } from './_segment/purchase'

const PURCHASE_TRACKED_KEY = 'purchaseTracked'

// Purchase must fire once per reservation; the in-memory guard in Tracking.tsx resets on
// remount/refresh, so persist a per-reservation flag for the tab session.
const hasTrackedPurchase = (reservationCode: string): boolean => {
  try {
    return sessionStorage.getItem(`${PURCHASE_TRACKED_KEY}:${reservationCode}`) === 'true'
  } catch {
    return false
  }
}

const markPurchaseTracked = (reservationCode: string): void => {
  try {
    sessionStorage.setItem(`${PURCHASE_TRACKED_KEY}:${reservationCode}`, 'true')
  } catch {
    // ignore storage errors (private mode, quota)
  }
}

export const trackConfirmation = (data: TrackingData, basketId: string | undefined): void => {
  const products = getProducts(data)
  const cookieConsent = getCookieConsent()
  if (products) {
    if (data.reservationCode && hasTrackedPurchase(data.reservationCode)) return

    trackPurchaseEcommerce(data, products)

    logFrontendInfo('Purchase event has been tracked', {
      ...cookieConsent,
      basketId,
      page: window.location.pathname,
      path: window.location.href,
      referer: document.referrer,
      sessionId: getSession()?.sessionId,
    })

    // this is needed for Kibana 'PAXOB - Frontend' Baskets Confirmation visualization/dashboard
    logFrontendInfo('purchase logging - BasketId: {@BasketId} ReservationCode: {@ReservationCode}', {
      basketId,
      method: 'GET',
      page: 'confirmation',
      path: `/confirmation/${data.reservationCode}`,
      reservationCode: data.reservationCode,
      sessionId: getSession()?.sessionId,
    })

    if (basketId) trackOrderCompletedSegment(data, products, basketId)

    if (data.reservationCode) markPurchaseTracked(data.reservationCode)
  } else {
    logFrontendInfo(`Purchase missing products`, {
      ...cookieConsent,
      basketId,
      page: window.location.pathname,
      path: window.location.href,
      referer: document.referrer,
      sessionId: getSession()?.sessionId,
    })
  }
}
